<template>
    <div class="about-root">

   <div class="about-page" id="aboutInfo">
<div class="text"><div class="button"><i class="material-icons" id="closeButton" v-on:click="theButton">close</i></div>

<p>
              The Thomas Booker Rare Fish Library was created by <a href="http://jessicaduffinwolfe.com">Jessica Duffin Wolfe</a> and stars rare book illustrations from the <a href="https://www.bl.uk/">British Library</a>. Its title is a tribute to its inspiration, Toronto’s <a href="">Thomas Fisher Rare Book Library</a>. 
</p>
             <p> No fish or books were harmed in the making of this film, which floats with gratitude on <a href="https://aframe.io/">A-Frame</a> and <a href="https://vuejs.org/">Vue.js</a>.</p>

<div class="illustrations-title">Book Illustration Credits</div>


<div class="books">
<div v-for="book in orderedBooks" :key="book.Shelfmark"><div class="citation"><p class="citation-line">{{book.Author}}. <span class="book-title">{{book.Title}}</span>, {{book.Year}}: {{book.Page}}{{book.Pages}}. {{book.Shelfmark}} <a :href="book.Flickr" target="_blank">Flickr</a></p></div></div>
</div>
        </div>
</div>
</div>
</template>
<script>

    import theBooks from '../theBooks'
    import _ from 'lodash'

        export default {
  name: 'about',
  data() {
      return {
    theBooks  }
  },
computed: {
  orderedBooks: function() {
    return _.orderBy(this.theBooks, 'Author')
  }
},
  methods: {
    theButton: function() {


      this.$emit('clicked', 'Hide About.')
   

      
    }
  }
}

</script>
<style>

#closeButton {
  cursor: pointer;
}
body {
  background-color: #001350;
  color:#18ffff;
}


.about-root {position: absolute; top: 0;}
.about-page {background-color: rgba(24, 25,255,1.0);
    font-family: 'Didact Gothic';
    position: relative;
    height: 100vh;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 5% 0;
    font-size: 1.25em;
    letter-spacing: 1px;
    z-index: 2000;
    color: rgb(24, 255, 255); 
    overflow: scroll;
    line-height: 150%;}

.about-page a {color: inherit;text-decoration: underline;}

.text {    width: 70%;
    margin: 0 auto;}
.button { text-align: center;    
}
.button .material-icons {font-size: 8rem!important;}

.illustrations-title {    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 50px;
    font-size: 80%;}
    
p.citation-line {text-indent: -28px;
padding-left: 28px;}

.book-title {font-style: italic;}
</style>